export interface WorldViewBounds {
  min: { x: number; y: number; z: number };
  max: { x: number; y: number; z: number };
}

export interface WorldViewMetrics {
  center: { x: number; y: number; z: number };
  size: { x: number; y: number; z: number };
  radius: number;
  cameraDistance: number;
  farPlane: number;
  maximumOrbitDistance: number;
  fogScale: number;
}

export function calculateWorldViewMetrics(
  bounds: WorldViewBounds,
  verticalFovDegrees = 52,
  aspect = 16 / 9
): WorldViewMetrics {
  const size = {
    x: Math.max(1, bounds.max.x - bounds.min.x + 1),
    y: Math.max(1, bounds.max.y - bounds.min.y + 1),
    z: Math.max(1, bounds.max.z - bounds.min.z + 1)
  };
  const center = {
    x: (bounds.min.x + bounds.max.x) / 2,
    y: (bounds.min.y + bounds.max.y) / 2,
    z: (bounds.min.z + bounds.max.z) / 2
  };

  const radius = Math.max(
    6,
    Math.hypot(size.x, size.y, size.z) / 2
  );
  const safeAspect =
    Number.isFinite(aspect) && aspect > 0 ? aspect : 1;
  const verticalHalfAngle = Math.max(
    0.12,
    (Math.max(10, verticalFovDegrees) * Math.PI / 180) / 2
  );
  const horizontalHalfAngle = Math.atan(
    Math.tan(verticalHalfAngle) * safeAspect
  );
  const limitingHalfAngle = Math.max(
    0.12,
    Math.min(verticalHalfAngle, horizontalHalfAngle)
  );

  const cameraDistance =
    (radius / Math.sin(limitingHalfAngle)) * 1.12;
  const farPlane = Math.max(
    500,
    cameraDistance + radius * 2.2 + 64
  );
  const maximumOrbitDistance = Math.max(
    190,
    cameraDistance * 1.55
  );
  const fogScale = Math.max(1, radius / 72);

  return {
    center,
    size,
    radius,
    cameraDistance,
    farPlane,
    maximumOrbitDistance,
    fogScale
  };
}
